export const buildBaseUrl = (teamId) => {
  return `/sm/team/${teamId}/key-sets`
}
